import { IPatientProfile } from '@interfaces/patient/patient-profileI';
import { BaseStateI } from '@interfaces/redux/base-state';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDataPatientByUsernameNew } from '@services/fc-user/fc-user';

export interface PatientProfileState extends BaseStateI {
    patientProfile: IPatientProfile | null;
}

export const fetchPatientProfile = createAsyncThunk(
    'patient/fetchPatientProfile',
    async (patientUsername: string, thunkAPI) => {
        const data = await getDataPatientByUsernameNew(patientUsername);
        return data;
    }
);

const patientProfileSlice = createSlice({
    name: 'patient-profile',
    initialState: {
        error: null,
        patientProfile: null,
        status: 'idle',
    } as PatientProfileState,
    reducers: {
        resetPatient: (state) => {
            state.error = null;
            state.patientProfile = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientProfile.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientProfile.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientProfile.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.patientProfile = action.payload;
        });
    },
});

export const { resetPatient } = patientProfileSlice.actions;
export default patientProfileSlice.reducer;
